import { notification as antdNotification } from "antd";
import {
  CheckCircleOutlined,
  InfoCircleOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { getI18n } from "react-i18next";

export interface NotificationParams {
  type: "success" | "info" | "warning" | "error";
  description: string;
  title?: string;
  placement?: null | "top" | "topLeft" | "topRight" | "bottom" | "bottomLeft" | "bottomRight";
}

const icons = {
  success: <CheckCircleOutlined style={{ color: "green" }} />,
  error: <CloseCircleOutlined style={{ color: "red" }} />,
  info: <InfoCircleOutlined style={{ color: "gray" }} />,
  warning: <ExclamationCircleOutlined style={{ color: "yellow" }} />,
};

const defaultTitle = {
  success: "Success",
  error: "Error",
  info: "Info",
  warning: "Warning",
};

export default (params: NotificationParams) => {
  const { type, title, description, placement } = params;
  const i18n = getI18n();
  antdNotification[type]({
    message: i18n.t(title || defaultTitle[type]),
    description: i18n.t(description),
    placement: placement || "bottomRight",
    icon: icons[type],
  });
};

export const httpErrorMessage = (action: any) => {
  const status = action.payload.status;
  const message = action.payload.data?.errorMessage ?? null;

  if (status === 500) return "Something went wrong!";
  if (status === 429) return "Too many requests! Try again later.";
  if (status === 403) return "Something went wrong! Please login again.";

  return message || "Something went wrong!";
};
